<template>
  <div class="cards">
    <v-container fluid>
      <v-row dense>
        <v-col
          v-for="card in cards"
          :key="card.title"
          :cols="card.flex"
          class="pa-6"
        >
          <v-card
            elevation="2"
            outlined
            tile
            @click="goToPage(card.subdomain)"
          >
              <v-card-title class="black--text align-end text-h6" v-text="card.title"></v-card-title>
            <v-img
              :src="getImgUrl(card.subdomain)"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="200px"
            >
              <!-- <v-card-title v-text="card.title"></v-card-title> -->
            </v-img>

              <!-- <v-card-subtitle class="black--text align-end text-h6 blue-grey lighten-5 justify-center--text" v-text="card.title"></v-card-subtitle> -->
            <v-card-actions >
              <!-- <v-spacer></v-spacer> -->
              <v-btn icon>
                <v-icon v-if="card.public" @click="goToPaper(card.paperURL)">mdi-book-open-outline</v-icon>
              <v-icon v-else class="black--text">mdi-lock</v-icon>
              </v-btn>
                <div class="blue--text" v-if="card.public">{{ card.paperText }}</div>
                <div v-else>PASSWORD ACCESS ONLY</div>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
    name: "cards",
    data: () => ({
      cards: [
        { title: 'ProKAP: Pancancer KEA3', public: true, subdomain: 'pancan-kea3', flex: 12, paperText: 'Calinawan et al. CPTAC Pancancer Phosphoproteomics Kinase Enrichment Analysis with ProKAP Provides Insights into Immunogenic Signaling Pathways. Biorxiv preprint.', paperURL: 'https://www.biorxiv.org/content/10.1101/2021.11.05.450069v1'  },
        { title: 'clear cell Renal Cell Carcinoma (ccRCC)', public: true, subdomain: 'ccrcc', flex: 6, paperText: 'Clark, et al. (2019). Integrated Proteogenomic Characterization of Clear Cell Renal Cell Carcinoma. Cell, 179(4), 964-983.e31', paperURL: 'https://doi.org/10.1016/j.cell.2019.10.007' },
        { title: 'Pediatric Brain Tumor (PBT)', public: true, subdomain: 'pbt', flex: 6 , paperText: 'Petralia, et al. (2020). Integrated Proteogenomic Characterization across Major Histological Types of Pediatric Brain Cancer. Cell, 183(7), 1962-1985.e31', paperURL: 'https://doi.org/10.1016/j.cell.2020.10.044', },
        { title: 'High-grade serous ovarian cancer: Human tissue', public: true, subdomain: 'ptrc', flex: 6, paperText: 'Huang et al. Multiomic analysis identifies CPT1A as a potential therapeutic target in platinum-refractory high grade serous ovarian cancer. Cell Medicine Report, 2021, imprint', paperURL: ''},
        { title: 'High-grade serous ovarian cancer: Cell line', public: false, subdomain: 'ptrc-cell-line', flex: 6, paperText: '', paperURL: '' },
        { title: 'Pancancer Pathway Analysis',public: false, subdomain: 'pancan',  flex: 6, paperText: '', paperURL: ''},
     ],
    }),
    methods: {
        goToPage(cardUrl) {
            window.open(
                `http://${cardUrl}.cptac-data-view.org`, 
                '_blank'
            );
        },
        goToPaper(paperURL) {
            window.open(
                paperURL, 
                '_blank'
            );
        },
        getImgUrl(pic) {
          try {
            return require('@/assets/'+pic+'.png')
          } catch {
            return ''
          }
        },
    }
}
</script>

<style>
.cards{
    width: 100%;
}
</style>